import { NgTemplateOutlet } from "@angular/common";
import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ButtonComponent } from "@components/button/button.component";
import { CheckboxComponent } from "@components/checkbox/checkbox.component";
import { InputComponent } from "@components/input/input.component";
import { ListColumnDirective } from "@components/list/list-column.directive";
import { ListComponent } from "@components/list/list.component";
import { SearchComponent } from "@components/search/search.component";
import { TabComponent } from "@components/tabs/tab/tab.component";
import { TabsComponent } from "@components/tabs/tabs.component";
import { TextmultilineComponent } from "@components/textmultiline/textmultiline.component";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslatePipe } from "@ngx-translate/core";
import { BusySpinnerComponent } from "~app/common/components/busy/busy-spinner/busy-spinner.component";
import { ConfirmDialogResponse } from "~app/common/models/constants";
import { ISearchVirkesleverantorRequest } from "~app/features/virkeskop/virkesleverantor/models/virkesleverantorModel";
import { VirkesleverantorService } from "~app/features/virkeskop/virkesleverantor/services/virkesleverantor.service";
import { VkKartaFastigheterComponent } from "../../karta/vk-karta-fastigheter/vk-karta-fastigheter.component";
import { LeverantorListItem } from "./sok-leverantor-model";

@Component({
    selector: "rask-sok-leverantor-modal",
    templateUrl: "./sok-leverantor-modal.component.html",
    styleUrls: ["./sok-leverantor-modal.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TabsComponent,
        TabComponent,
        NgTemplateOutlet,
        VkKartaFastigheterComponent,
        InputComponent,
        FormsModule,
        SearchComponent,
        TextmultilineComponent,
        ButtonComponent,
        ListComponent,
        ListColumnDirective,
        CheckboxComponent,
        TranslatePipe,
        BusySpinnerComponent
    ]
})
export class SokLeverantorModalComponent {
    modal = inject(NgbActiveModal);

    protected leverantorer: LeverantorListItem[] = [];
    protected resultMessage = "Sök på leverantör för att hitta leverantörer att lägga till i avtalet";
    protected searchAddress = "";
    protected searchAnsvarigvirkeskopare = null;
    protected searchLeverantorsnummer = "";
    protected searchNameCityPnr = "";
    protected searchPhonenumber = "";
    protected selectedTab: string;

    protected isSearching = false;

    private readonly virkesleverantorService = inject(VirkesleverantorService);

    private _config = { openTab: null };

    get config() {
        return this._config;
    }

    set config(value) {
        this._config = value;
        this.selectedTab = this._config?.openTab;
    }

    add(): void {
        const result = this.leverantorer.filter(l => l.checked === true).map(l => l.model);
        this.modal.close(result);
    }

    ansvarigVirkeskopareChanged($event) {
        this.searchAnsvarigvirkeskopare = $event ? $event.kod : null;
    }

    ansvarigVirkeskopareCompareWith(item, selected) {
        return item.id === selected.id;
    }

    canAdd(): boolean {
        return this.leverantorer.some(l => l.checked === true);
    }

    dismiss(): void {
        this.modal.close(ConfirmDialogResponse.cancel);
    }

    fastighetImported($event): void {
        this.modal.close($event);
    }

    search(): void {
        const request = {} as ISearchVirkesleverantorRequest;
        request.adressParam = this.searchAddress;
        request.limeId = this.searchLeverantorsnummer;
        request.telefonParam = this.searchPhonenumber;
        request.sok = this.searchNameCityPnr;
        request.ansvarigVirkeskopare = this.searchAnsvarigvirkeskopare ?? "";
        request.take = 50;
        this.isSearching = true;
        this.virkesleverantorService.searchForVirkeskopsleverantor(request).subscribe(result => {
            this.leverantorer = result.map(r => new LeverantorListItem(r));
            if (this.leverantorer?.length === 0) {
                this.resultMessage = "Inga leverantörer hittades.";
            } else {
                this.resultMessage = "";
            }
            this.isSearching = false;
        });
    }

    getAnvandareTypeAhead = (input: string) => this.virkesleverantorService.getAnvandareTypeAhead(input);
}
